import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  MasonryCTACardNodeActions,
  MasonryCTACardProperties,
} from 'common/masonry-types';
import { MasonryCTACardRenderer } from './masonry-cta-card-renderer.component';

/** What `driver.nodeRendererRegistry.overrideRenderer` expects for the third argument. */

const NODE_IDS_FOR_CUSTOM_BACKGROUND_COLOR = [
  'care-services$myPersonalRecordsCard',
  'care-services$myAHSConnect',
  'care-services$myPersonalRecordsAuthenticatedCard',
  'care-services$myAHSConnectAuthenticated',
  'care-services$viewMobileHealthCardUnauthenticatedServices',
  'care-services$viewMobileHealthCardAuthenticatedServices',
  'care-services$parentOrGuardianAccessUnauthenticatedServices',
  'care-services$parentOrGuardianAccessAuthenticatedServices',
];

type MasonryCTACardNode = MasonryEngineNode<
  'ctaCard',
  MasonryCTACardProperties,
  MasonryCTACardNodeActions
>;

type MasonryCTACardRendererProps =
  MasonryEngineNodeRendererProps<MasonryCTACardNode>;

export const CareServiceCTACardRenderer = (
  props: MasonryCTACardRendererProps,
) => {
  const { nodeData, nodeId, ...restProps } = props;

  const backgroundColor = NODE_IDS_FOR_CUSTOM_BACKGROUND_COLOR.includes(nodeId)
    ? '$surfaceBackgroundPrimary'
    : '$surfaceBackgroundTertiary';

  return (
    <MasonryCTACardRenderer
      styles={{
        backgroundColor,
      }}
      nodeId={nodeId}
      nodeData={nodeData}
      {...restProps}
    />
  );
};
